export default __webpack_public_path__ + "static/media/mappin.24efdbf3.jpg";